/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import AlertIcon from 'mdi-react/AlertIcon';
import { useBasicAuth } from '../../../shared/components/auth/withBasicAuth';
import { environment } from '../../environment';
import { util } from "../../../shared/util";

let img = `${process.env.PUBLIC_URL}/img/products/`;

class TopbarAlert extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      intervalId: 0,
      showAlert: false,
      showAlertOK: true,
      notifications: []
    };
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  load(){  
    if(useBasicAuth.checkTokenExists()){
      if(environment.isAdmin()){
        //this.loadStocks(); this.buildNotifications(dataS, dataO);
      }
    }else{
      clearInterval(this.state.intervalId);
    }
  }

  init(){
    const loadBounded = this.load.bind(this);
    if(this.state.intervalId === 0){
      let intervalId = setInterval(loadBounded, 10000);
      this.setState({intervalId: intervalId}, () => {
        this.load();
      });
    }
  }

  getPercent(v1, v2){
    return (v1/v2)*100;
  }

  buildNotifications(dataS, dataO){
    let notifications = [];
    let showAlert = false;
    let stock = {};
    let order = {}
    let qty = 0;
    let sum = 0;
    let replacementTime = 0;
    let averageConsumption = 0;
    let averageConsumptionDaily = 0;

    let percentStockMinAfter = 0;
    let expectedDuration = 0;
    let expectedDurationInteger = 0;
    let expectedDurationDecimal = 0;

    if(dataS !== null && dataS !== undefined && dataS.length > 0 &&
      dataO !== null && dataO !== undefined && dataO.length > 0){
    
      for(let i = 0; i < dataS.length; i++){
        stock = dataS[i];
        qty = stock.qtyStock;
        sum = qty;
        replacementTime = stock.replacementTime;
        averageConsumption = stock.averageConsumption;
        averageConsumptionDaily = averageConsumption/environment.BASE_CALC_DAILY;
        order = {};

        percentStockMinAfter = 0;
        expectedDuration = 0;

        for(let j = 0; j < dataO.length; j++){
          order = dataO[j];

          if(stock.product.id === order.product.id && order.status !== "CANCELED" && order.status !== "FINISHED" ){
            sum -= order.qty;
          }
        }

        expectedDuration = Math.round((sum/averageConsumptionDaily) * 10) / 10;
        expectedDurationInteger = Math.floor(expectedDuration);
        expectedDurationDecimal = expectedDuration % expectedDurationInteger;
        //console.log(expectedDurationDecimal);
        if(expectedDurationDecimal > 0.5){
          expectedDurationInteger += 1;
        }
        percentStockMinAfter = Math.round(this.getPercent((replacementTime * averageConsumptionDaily),sum) * 10) / 10;
        if(percentStockMinAfter > 70){
          let item = {
            ava: img + stock.product.type + '_' + stock.product.code + '_35.png',
            name: stock.product.name,
            message: this.props.t('forms.stock_form_edit.exhaustsApproximately') + " " + expectedDurationInteger + " " + this.props.t('forms.days'),
            stockId: stock.id,
            date: util.formatDateHoraToString(order.createdAt, "")
          }
          notifications.push(item);
          showAlert = true;
        }      
      }
      if(showAlert && this.state.showAlertOK){
        this.props.show('danger', this.props.t('alerts.dangerTitle'), this.props.t('alerts.dangerMessage'), '');
        this.setState({ notifications, showAlert, showAlertOK: false });
      }else{
        this.setState({ notifications, showAlert });
      }
    }
  }

  handleSubmit(stockId) {
    //useBasicAuth.redirectSearch(code);
  }

  componentDidMount() {
    //this.init();
  }

  render() {
    const { collapse } = this.state;
    const { t } = this.props;

    // MCCOSTA: Notifications Alert

    let iconAlert = "";
    if(this.state.showAlert){
      iconAlert = <div className="topbar__btn-new-label"><div /></div>
    }

    return (
      <div className="topbar__collapse">
        <style>
          {`
            .hover-div {
              background: #FFFFFF;
            }

            .hover-div:hover {
              background: #F8F8F8;
            }
          `}
        </style>
        <button className="topbar__btn topbar__btn--mail topbar__btn--new" type="button" onClick={this.toggle}>
          <AlertIcon />
          {iconAlert}
        </button>
        {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}
        <Collapse
          isOpen={collapse}
          className="topbar__collapse-content topbar__collapse-content--alert"
        >
          <div className="topbar__collapse-title-wrap">
            <p className="topbar__collapse-title">{t('alerts.title')}</p>
            <Link className="topbar__collapse-button" to="/forms/stockentry" onClick={this.toggle}>
              {t('alerts.markAllAsRead')}
            </Link>
          </div>
          {this.state.notifications.map((notification, index) => (
            <div className="topbar__collapse-item hover-div" key={index} 
              onClick={() => this.handleSubmit(notification.stockId)}
              style={{cursor: "pointer"}}>
              <div className="topbar__collapse-img-wrap" style={{borderRadius: 0}}>
                <img className="topbar__collapse-img" src={notification.ava} alt="" />
              </div>
              <p className="topbar__collapse-message" style={{color: "red"}}>
                <span className="topbar__collapse-name">{notification.name}</span>
                <br />
                {notification.message}
              </p>
              <p className="topbar__collapse-date">{notification.date}</p>
            </div>
          ))}
          <Link className="topbar__collapse-link" to="/forms/stockView" onClick={this.toggle}>
            {t('alerts.seeAll')}
          </Link>
        </Collapse>
      </div>
    );
  }
}

export default withTranslation('common')(TopbarAlert);